export default __webpack_public_path__ + "static/media/Icon5.8c84dff5.png";